import * as Sentry from "@sentry/react";

export function initSentry() {
  if (!import.meta.env.PROD) return;

  Sentry.init({
    dsn: "https://a6b777c5f9a98cd3f8d0a2d5bf09e1b3@o4505114197491712.ingest.us.sentry.io/4510947929554944",
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
